import {
	ListName,
	ListPageType,
	Product,
	Tracker,
	StudyCardImpressionData,
	ClickEcommerceTrackingData,
	ProductType,
	Action,
} from '@studyportals/datalake-event-tracker';
import { ITrackingData } from '@studyportals/datalake-event-tracker/dist/src/interfaces/tracking-data.interface';
import { DataStorage } from '@studyportals/data-storage';
import { IItemContext } from "@studyportals/datalayer";

import Logger from '@/search-page/platform/Logger';
import StudyCard from '../../presentation/components/study-card/StudyCard.class';

class Tracking {
	private tracker = new Tracker(Product.SEARCH_PAGE);

	public snowPlowSiteSearch(searchTerms: string[], filters: object, resultsFound: number): void {
		if (typeof window.snowplow === 'undefined') {
			Logger.logError('Snowplow not found!');
			return;
		}

		if (searchTerms.length === 0) {
			Logger.logError('Snowplow enrich rejects empty searchTerms.');
		}

		window.snowplow('trackSiteSearch', {
			terms: searchTerms,
			filters,
			totalResults: resultsFound
		});
	}

	public searchCardImpression(studyCard: StudyCard): void {
		const data: StudyCardImpressionData = new StudyCardImpressionData(
			studyCard.cardId.value,
			ListPageType.SEARCH,
			ListName.SEARCH_PAGE,
			studyCard.organisationId.value,
			undefined,
			undefined,
			this.getOrder(studyCard),
			undefined,
			undefined
		);

		try {
			this.tracker.trackStudyCardImpression(data);
		} catch (error) {
			Logger.logError(JSON.stringify(error));
		}
	}

	public searchCardClick(studyCard: StudyCard): void {
		const data = new ClickEcommerceTrackingData(
			studyCard.cardId.value,
			ListPageType.SEARCH,
			ListName.SEARCH_PAGE,
			studyCard.organisationId.value,
			undefined,
			undefined,
			this.getOrder(studyCard),
			undefined,
			undefined,
			ProductType.STUDY
		);

		try {
			this.storeTrackingData(data.getTrackingContext());

			this.tracker.trackStudyCardClick(data);
		} catch (error) {
			Logger.logError(JSON.stringify(error));
		}
	}

	public trackCustomClickEvent(label: string, property: string): void {
		const trackingData: ITrackingData = {
			action: Action.CLICK,
			label,
			property
		};

		try {
			this.tracker.trackStructuredEvent(trackingData);
		} catch (error) {
			Logger.logError(JSON.stringify(error));
		}
	}
	public trackCustomImpressionEvent(label: string, property: string): void {
		const trackingData: ITrackingData = {
			action: Action.SEND,
			label,
			property,
			category: Product.SEARCH_PAGE
		};

		try {
			this.tracker.trackStructuredEvent(trackingData);
		} catch (error) {
			Logger.logError(JSON.stringify(error));
		}
	}

	public trackResponseTime(time: number, variation: string): void {
		const trackingData: ITrackingData = {
			action: Action.TIME_SPENT,
			label: `search_api_response_time_${variation}`,
			property: 'programme_search',
			value: time
		};

		try {
			this.tracker.trackStructuredEvent(trackingData);
		} catch (error) {
			Logger.logError(JSON.stringify(error));
		}
	}

	private storeTrackingData(context: IItemContext): void {
		const key = 'StudyCardClick';
		const value = DataStorage.retrieve(key) as string;
		let data: IItemContext[] = [];
		if (value !== '') {
			data = data.concat(JSON.parse(value) as []);
		}

		data.push(context);

		DataStorage.store(key, JSON.stringify(data), 30);
	}

	private getOrder(studyCard: StudyCard): number {
		if (studyCard.order.value) {
			return studyCard.order.value;
		}

		throw new Error("Study card doesn't have the order properly set");
	}
}

export default new Tracking();
